<template>
  <div class="widget form-widget pb-2">
    <div class="widget-content">
      <div class="panel-body rounded-pills-icon tabs">
        <ul
          id="languageTab"
          class="nav nav-pills mb-4 mt-3 justify-content-center align-items-center flex-md-row flex-column"
          role="tablist"
        >
          <li v-for="tab in tabs" :key="tab.code" class="nav-item ms-md-2 me-md-2 me-0 ms-0 h-100" role="presentation">
            <a
              :id="'tab-' + tab.code + '-tab'"
              :ref="'ref-' + tab.code"
              :aria-controls="'tab-' + tab.code"
              :aria-selected="currentTabCode && currentTabCode === tab.code"
              :aria-disabled="tab.disabled"
              :class="
                'nav-link mb-2 text-center bgStyle h-100' +
                (currentTabCode && currentTabCode === tab.code ? ' active' : '') +
                (tab.hidden ? ' d-none' : '') +
                (defaultColors ? ' defaultColors' : '') +
                (tab.disabled ? ' disabled' : '')
              "
              :href="'#tab-' + tab.code"
              data-bs-toggle="pill"
              role="tab"
              @click="toggleTab(tab.code, tab.disabled)"
            >
              <FontAwesomeIcon :icon="'fa-light fa-' + tab.icon" />
              {{ tab.title }}
            </a>
          </li>
        </ul>
        <div id="languageTabContent" class="tab-content">
          <div
            v-for="tab in tabs"
            :id="'tab-' + tab.code"
            :key="tab"
            :aria-labelledby="'tab-' + tab.code + '-tab'"
            :class="
              'tab-pane fade' +
              (currentTabCode && currentTabCode === tab.code ? ' show active' : '') +
              (tab.hidden ? ' d-none' : '')
            "
            role="tabpanel"
          >
            <template v-if="tab.models">
              <RegistrationCompanyGeneralTabComponent
                :loading="loading"
                :data="tab.models"
                v-if="'informations' === tab.code"
              />
              <RegistrationCompanyContractTabComponent
                :loading="loading"
                :contracts="tab.models"
                v-if="tab.code === 'contracts'"
              />
              <RegistrationCompanyContactTabComponent
                :loading="loading"
                :contacts="tab.models"
                v-if="tab.code === 'contacts'"
                @removeContact="removeContact"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiConnection } from "@/services/api-connection";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import RegistrationCompanyGeneralTabComponent from "@/components/registration/company/RegistrationCompanyGeneralTabComponent.vue";
import RegistrationCompanyContractTabComponent from "@/components/registration/company/RegistrationCompanyContractTabComponent.vue";
import RegistrationCompanyContactTabComponent from "@/components/registration/company/RegistrationCompanyContactTabComponent.vue";

export default {
  data() {
    return {
      loading: false,
      tabs: [],
      id: null,
      currentTabCode: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.id = this.$route.params.id;
      if (!window.location.hash) {
        this.setCurrentTabCode("informations");
      } else {
        this.setCurrentTabCode(window.location.hash.substring(1));
      }
      apiConnection
        .get("/app/studea-manager/training/insee-company/tabs/" + this.currentTabCode + "/" + this.id, {}, true)
        .then((data) => {
          this.tabs = data.tabs;
          this.loading = false;
          this.setAppLoading(false);
        });
    },

    toggleTab(code) {
      this.setCurrentTabCode(code);
      this.init();
    },

    setCurrentTabCode(code) {
      this.currentTabCode = code;
      window.location.hash = this.currentTabCode;
    },

    cancel() {
      this.$router.push({
        name: "RegistrationCompanyList",
      });
    },

    ...mapActions(useMainStore, { setAppLoading: "setAppLoading" }),
  },
  components: {
    RegistrationCompanyContactTabComponent,
    RegistrationCompanyContractTabComponent,
    RegistrationCompanyGeneralTabComponent,
  },
};
</script>

<style lang="scss" scoped>
.widget .nav-link {
  min-height: 130px;
  width: 130px !important;
  @include up-to-md {
    min-height: fit-content;
    width: 100% !important;
  }
}
</style>
